export function getPromoFromArray(promoArray) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const promo = searchParams.get('promo') || searchParams.get('promokey');
    if (!promo) {
        return null;
    }

    if (promoArray && promoArray.length) {
        const foundPromo = promoArray.find(item => item.promokey === promo);
        return foundPromo || null;
    }
    return null;
};
